import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';


@Component({
  selector: 'app-student-attendance-details',
  templateUrl: './student-attendance-details.component.html',
  styleUrls: ['./student-attendance-details.component.css']
})
export class StudentAttendanceDetailsComponent implements OnInit {

  constructor(private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }
  MonthName (monthNumber) { //1 = January
    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    return monthNames[monthNumber - 1];
}
   dt = new Date();
        SearchModel = {
            SessionID: 0,
            StudentAttendanceID: 0,
            AtYear: this.dt.getFullYear(),
            AtMonth: (this.dt.getMonth() + 1).toString(),
        }
                TotalP = 0;
                TotalO = 0;
                TotalA = 0;
                TotalH = 0;
                TotalF = 0;
                MaxDayInMonth = 0;
        GetStudentAttendanceDetails_StudentPortal  () {
          
            this.studentPortalService.GetStudentAttendanceDetails_StudentPortal(this.SearchModel.AtMonth, this.SearchModel.AtYear).subscribe((data: any) => {
                this.WeekDaysList = data.WeekDaysList;
                this.TotalP = data.TotalP;
                this.TotalO = data.TotalO;
                this.TotalA = data.TotalA;
                this.TotalH = data.TotalH;
                this.TotalF = data.TotalF;
                this.MaxDayInMonth = data.MaxDayInMonth;
              
               

            });

        }
           AttMsg="";
           WeekDaysList = [];
           StudentAttendanceReportList:any;
        GetStudentAttendanceYearly_StudentPortal  () {
            this.AttMsg = 'There is no attendance records found';
            this.WeekDaysList = [];
            this.studentPortalService.GetStudentAttendanceYearly_StudentPortal(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
                this.StudentAttendanceReportList = response.StudentAttendanceReportList;
                if (response.StudentAttendanceReportList != null) {
                    this.AttMsg = '';
                 this.GetDetails(this.StudentAttendanceReportList[0], 0);
                }
                else {
                    this.AttMsg = 'There is no attendance records found';
                }

            });
        };
        selectedIndex:any;
        CalendarNext  () {
            if (this.selectedIndex < this.StudentAttendanceReportList.length-1) {
                this.selectedIndex = this.selectedIndex + 1;
                this.GetDetails(this.StudentAttendanceReportList[this.selectedIndex], this.selectedIndex);
            }
        }
        CalendarPrevious  () {
            if (this.selectedIndex>0){
                this.selectedIndex = this.selectedIndex - 1;
                this.GetDetails(this.StudentAttendanceReportList[this.selectedIndex], this.selectedIndex);
            }
        }
        GetDetails  (item,index) {
            this.selectedIndex = index;
            this.SearchModel.AtMonth = item.AtMonth;
            this.SearchModel.AtYear=item.AtYear;
            this.GetStudentAttendanceDetails_StudentPortal();
        }
        SessionList:any;
        GetAcademicSession  () {

            this.lookupService.GetLookupsList('AcademicSession', '').subscribe((data: any) => {
                this.SessionList = data.LookupItems;
                this.SearchModel.SessionID = this.SessionList[1].ItemId;
                this.GetStudentAttendanceYearly_StudentPortal();
            });
        };
        YearList = [];
  ngOnInit() {

    var dtCurrent = new Date();
    var year = dtCurrent.getFullYear();
    this.YearList = [];
    var item = {
        ItemId: 0,
        ItemName: '---Select---'
    }
    this.YearList.push(item);
    for (var i = year; i >= year - 2; i--) {
        item = {
            ItemId: i,
            ItemName: i.toString()
        }
        this.YearList.push(item);
    }
    this.GetAcademicSession();
    //this.GetStudentFeeDetail_StudentPortal();
  }

}
